// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductImage_container__16w2E","picture":"ProductImage_picture__ARA0m","wmh":"ProductImage_wmh__Tqj6N"};